<script>
import { Slider } from 'vue-sliderx';

export default {
  name: 'UiTab',
  props: {
    activeTab: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      internalActiveTab: this.activeTab || this.$slots.default[0].key,
    };
  },
  watch: {
    activeTab () {
      this.internalActiveTab = this.activeTab;
    },
  },
  methods: {
    changeTab (value) {
      this.internalActiveTab = value;
      this.$emit('change', value);
    },
  },
  computed: {
    currentSlide (value) {
      return this.$slots.default.findIndex(({ key }) => key === this.internalActiveTab);
    },
  },
  components: {
    Slider,
  },
};
</script>

<template lang="pug">
div.ui-tab.bg-light-overlay.flex.flex-column
  nav.nav
    ul.navlist.flex
      cta-style(:inactive="key === internalActiveTab", v-for="({ key }) in $slots.default", :key="key")
        li.navitem.tc.flex-auto.pa3.fw7.bg-black-overlay.white.ttu.f6(:class="{'-active': key === internalActiveTab}", @click="changeTab(key)") {{ key }}
  div.tabs.flex.flex-auto.h-0
    slider.slider.flex-auto.h-0(ref="carousel", :current="currentSlide", orientation="horizontal", :per-page="1", )
      slot

</template>

<style scoped>
.ui-tab {
  & .navitem {
    box-shadow: none;
    &.-active {
      background: transparent;
      line-height: 1.5;
    }
  }
}
</style>
